export const getFarsiNumber = (num: number | string): string => {
	const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
	return num
		.toString()
		.split('')
		.map(digit => persianDigits[parseInt(digit, 10)])
		.join('');
};

export function formatMembersCount(count: number): string {
	if (count < 1000) {
		return count?.toString();
	} else if (count >= 1000 && count < 1_000_000) {
		return `+ ${(count / 1000).toFixed(1).replace(/\.0$/, '')} K`;
	} else if (count >= 1_000_000) {
		return `+ ${(count / 1_000_000).toFixed(1).replace(/\.0$/, '')} M`;
	}
	return count?.toString();
}

export function formatPrice(price: number): string {
	const formattedPrice = (price / 1000000).toFixed(0);
	return formattedPrice?.toString();
}

export function formatPricePersian(price: number): string {
	const priceInToman = price;
	const formattedPrice = priceInToman.toLocaleString('fa-IR');
	return formattedPrice;
}

export function formatNumberWithComma(number: number | undefined) {
	if (number !== undefined) {
		return number?.toLocaleString();
	}
}

export function formatToKMB(value: number): string {
	if (value >= 1_000_000_000) {
		return `${(value / 1_000_000_000).toFixed(1)}B`;
	}
	if (value >= 1_000_000) {
		return `${(value / 1_000_000).toFixed(1)}M`;
	}
	if (value >= 1_000) {
		return `${(value / 1_000).toFixed(1)}k`;
	}
	return value.toString();
}
